import React, { Fragment } from 'react';

export const EmptyState = ({ children, isEmpty, emptyState }) => {
    const EmptyState = emptyState;
    return isEmpty ? <EmptyState /> : <Fragment>{children}</Fragment>;
};



// WEBPACK FOOTER //
// ./src/UI/Containers/WithEmptyState/EmptyState.js